<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <fin-subscription-cards v-if="!showChangeAbo && !showCurrentAbo"
                              :price-models="priceModels"
                              :view-modes="viewModes"
                              @selectNewSubscription="val => doSubscriptionChange(val)"
                              @showSubscriptionDetails="val => showCurrentSubscriptionDetails(val)"/>
      <fin-subscription-change v-else-if="showChangeAbo"
                               :new-price-model="newPriceModel"
                               :abo-duration="aboDuration"
                               @cancelChange="cancelChange"/>
      <fin-current-subscription-details v-else-if="showCurrentAbo"
                                        :subscriptionData="subscriptionData"
                                        :price-model="priceModels.find(i => i.id === groupPriceModel.id)"
                                        @cancelShowDetails="cancelShowCurrentSubscription"
                                        @updateSubscription="val => updateSubscriptionData(val)"/>
    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import {API} from "@/plugins/finAmplifyModules"
import {listPriceModels, listPriceModelsGuests} from "@/components/pages/profile/graphql"
import FinSubscriptionCards from "@/components/pages/profile/subscription/Cards"
import FinSubscriptionChange from "@/components/pages/profile/subscription/Change"
import store from "@/store/index"
import FinCurrentSubscriptionDetails from "@/components/pages/profile/subscription/CurrentSubscriptionDetails"
import {getSubscriptionData} from "@/components/pages/profile/subscription/graphql"
import {graphqlOperation} from "@/plugins/finAmplifyModules"
import {mapGetters} from "vuex"

export default {
  name: "FinUserSubscription",
  components: {FinCurrentSubscriptionDetails, FinSubscriptionChange, FinSubscriptionCards, FinDataLoader},
  props: {
    /** a boolean indicating if the tab is active */
    active: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      priceModels: [],
      viewModes: [],
      aboDuration: '1M',
      showChangeAbo: false,
      showCurrentAbo: false,
      newPriceModel: null,
      showAboChangeViewToAboId: null,
      subscriptionData: null
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'groupPriceModel']),
  },
  methods: {
    async loadData() {
      const result = await API.graphql({
        // listPriceModelsGuests is called when a user is not logged in and is looking at the prices on the price page in Webflow (or on the url /abonnements).
        query: this.user ? listPriceModels : listPriceModelsGuests,
        authMode: store.getters["auth/publicQueryAuthMode"]
      })

      if (result) {
        this.priceModels = result.data.listPriceModels.items.filter(i => i.id !== 'DEVELOPER' && i.id !== 'TRIAL').sort((a, b) => a.order - b.order)
        this.priceModels.forEach(p => this.viewModes.push({id: p.id, details: false}))

        if (this.user) {
          // if the url contains the parameter changeToAboId=%aboId%, show the aboChangeView for this aboId
          // Ex: http://localhost:8080/protected/myProfile/subscription?changeToAboId=EXTENDED
          this.showAboChangeViewToAboId = this.$route.query.changeToAboId
          if (this.showAboChangeViewToAboId) {
            this.newPriceModel = this.priceModels.find(i => i.id === this.showAboChangeViewToAboId)
            this.aboDuration = null
            this.showChangeAbo = true
          }
        }
      }

      await this.loadSubscription()
    },
    async loadSubscription() {
      try {
        // check if the user is logged in, as the user is not logged in when he accesses the url /abonnements (access via webflow and iframe)
        if (this.user) {
          let result = await API.graphql(graphqlOperation(getSubscriptionData))
          if (result) {
            this.subscriptionData = result.data.getSubscriptionData
            console.log("loadSubscription this.subscriptionData", this.subscriptionData)
          }
        }
      } catch (err) {
        console.error("failed to get the subscription data", err)
      }
    },
    updateSubscriptionData(val) {
      console.log("updateSubscriptionData this.subscriptionData", val)
      const data = {
        ...this.subscriptionData,
        cancelAtPeriodEnd: val.cancelAtPeriodEnd
      }
      this.subscriptionData = data
      console.log("updateSubscriptionData this.subscriptionData", this.subscriptionData)
    },
    doSubscriptionChange(data) {
      const {priceModel, duration} = data
      this.newPriceModel = priceModel
      this.showChangeAbo = true
      this.aboDuration = duration
    },
    showCurrentSubscriptionDetails() {
      this.showCurrentAbo = true
    },
    cancelChange() {
      this.newPriceModel = null
      this.showChangeAbo = false
    },
    cancelShowCurrentSubscription() {
      this.showCurrentAbo = false
    },
  },
  watch: {
    // wenn the user goes to another tab, we reset this two boolean values in order to reset this component to its initial view
    active(newVal) {
      if (!newVal) {
        this.showChangeAbo = false
        this.showCurrentAbo = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
